import axios from "axios";
import { PBN, PBNSchema, PBNDto, pbnAiConvertToBool, pbnAiConvertToString } from "../types/PBN";
import qs from "qs";
import { toCamelCase, toSnakeCase } from "../utils/objectHelper";
export const PBNTransport = {
    list: async (params?: object): Promise<PBN[]> => {
        const { data } = await axios.get<PBN[]>(`/pbns${params ? `?${qs.stringify(params)}` : ""}`);
        return data.map((current) => PBNSchema.cast(toCamelCase(current)));
    },

    save: async (object: PBNDto, id: number | undefined | null): Promise<PBN> => {
        const newObject = {
            ...object,
            categoryAi: pbnAiConvertToBool(object.categoryAi),
            reviewAi: pbnAiConvertToBool(object.reviewAi),
            has_g_t_metrix: object.hasGTMetrix,
        };
        const response = await axios.request<PBN>({
            method: id ? "put" : "post",
            url: id ? `/pbns/${id}` : "/pbns",
            data: toSnakeCase(newObject),
        });

        return PBNSchema.cast(toCamelCase(response.data));
    },

    formTransformer: (object: PBN): PBNDto | null => {
        if (!object) {
            return null;
        }

        return {
            name: object.name,
            allowedIps: object.allowedIps,
            postByDefault: object.postByDefault,
            forLinking: object.forLinking,
            isPrivate: object.isPrivate,
            allowedCountries: object.allowedCountries,
            serverIp: object.serverIp,
            imageAi: object.imageAi,
            categoryAi: pbnAiConvertToString(object.categoryAi),
            reviewAi: pbnAiConvertToString(object.reviewAi),
            contactGroupId: object.contactGroupId,
            intentSearch: object.intentSearch,
            internalLinking: object.internalLinking,
            imageInBody: object.imageInBody,
            youtubeInBody: object.youtubeInBody,
            humanise: object.humanise,
            hasGTMetrix: object.hasGTMetrix,
            cloudflareApiKey: object.cloudflareApiKey,
            cloudflareApiSecret: object.cloudflareApiSecret,
            registrarIds: object.registrarAccount?.map((registrar) => registrar.id?.toString()),
            pbnT1: object.pbnT1?.map((pbnT1) => pbnT1.toString()),
            pbnT2: object.pbnT2?.map((pbnT2) => pbnT2.toString()),
            gptOption: object.gptOption,
        };
    },

    toggleActive: async (pbn: PBN): Promise<void> => {
        const action = "toggleActive";
        await axios.patch<PBN>(`/pbns/${pbn.id}/actions/${action}`);
    },

    currentUsingIn: async (pbn: PBN): Promise<Array<{ total: string }>> => {
        const action = "findIsUsed";
        const { data } = await axios.get<Array<{ total: string }>>(
            `/pbns/${pbn.id}/actions/${action}`
        );
        return data;
    },
};
